import React from "react";

export type SnackbarContextProps = {
  setMessage: (message: string, type?: string) => void;
};

const GlobalSnackbarContext = React.createContext<SnackbarContextProps>({
  setMessage: () => {},
});

export default GlobalSnackbarContext;

export const withGlobalSnackbar = (
  Wrapped: React.ClassType<any, any, any>,
): any => (props: any) => {
  function createContextConsumer(context: SnackbarContextProps) {
    return <Wrapped {...props} {...context} />;
  }

  return (
    <>
      <GlobalSnackbarContext.Consumer>
        {createContextConsumer}
      </GlobalSnackbarContext.Consumer>
    </>
  );
};
